import { Injectable } from "@nestjs/common";
import { Repository } from "typeorm";
import { InjectRepository } from "@nestjs/typeorm";
import { GAPOrdersEntity } from "../entities/gap-orders.entity";
import { GapOrderFilter } from "packages/libs/shared-models/src/common/gap/gap-order-filter";
import { ExternalReq } from "packages/libs/shared-models/src/common/pvh/externalreq";



@Injectable()
export class GAPOrdersRepository extends Repository<GAPOrdersEntity> {

    constructor(@InjectRepository(GAPOrdersEntity) private gapOrdersRepo: Repository<GAPOrdersEntity>
    ) {
        super(gapOrdersRepo.target, gapOrdersRepo.manager, gapOrdersRepo.queryRunner);
    }


    async getorderDataForInfo(req: GapOrderFilter): Promise<any[]> {
        console.log(req)
        const query = this.createQueryBuilder('o')
            .select(`*`)
        if (req?.poNumber !== undefined) {
            const poNumbers = req.poNumber.split(',').map(poNumber => poNumber.trim());
            query.andWhere(`o.po_number IN (:...poNumbers)`, { poNumbers });
        }

        if (req?.deliveryDateStartDate !== undefined && req?.deliveryDateEndDate !== undefined) {
            query.andWhere(`STR_TO_DATE(o.delivery_date, '%m/%d/%Y') BETWEEN STR_TO_DATE(:startDate, '%m/%d/%Y') AND STR_TO_DATE(:endDate, '%m/%d/%Y')`, {
                startDate: req.deliveryDateStartDate,
                endDate: req.deliveryDateEndDate
            });
        }
        if (req.externalRefNo !== undefined) {
            query.andWhere(`o.buyer_name ='${req.externalRefNo}'`)
        }
        query.andWhere(`o.status != 'ACCEPTED'`);

        return await query.getRawMany()
    }

    async getorderacceptanceData(req: GapOrderFilter): Promise<any[]> {
        console.log(req)
        const query = this.createQueryBuilder('o')
            .select(`*`)
        if (req?.poNumber !== undefined) {
            const poNumbers = req.poNumber.split(',').map(poNumber => poNumber.trim());
            query.andWhere(`o.po_number IN (:...poNumbers)`, { poNumbers });
        }

        if (req?.deliveryDateStartDate !== undefined && req?.deliveryDateEndDate !== undefined) {
            query.andWhere(`STR_TO_DATE(o.delivery_date, '%m/%d/%Y') BETWEEN STR_TO_DATE(:startDate, '%m/%d/%Y') AND STR_TO_DATE(:endDate, '%m/%d/%Y')`, {
                startDate: req.deliveryDateStartDate,
                endDate: req.deliveryDateEndDate
            });
        }
        if (req.externalRefNo !== undefined) {
            query.andWhere(`o.buyer_name ='${req.externalRefNo}'`)
        }
        query.andWhere(`o.status != 'ACCEPTED'`);

        return await query.getRawMany()
    }

    async getordercomparationData(req?: GapOrderFilter): Promise<any[]> {
        const query = this.createQueryBuilder('o')
            .select(`*`)
        if (req.poNumber !== undefined) {
            query.andWhere(`o.po_number ='${req.poNumber}'`)
        }
        if (req.externalRefNo !== undefined) {
            query.andWhere(`o.buyer_name ='${req.externalRefNo}'`)
        }

        return await query.getRawMany()
    }


}
